import { createFileRoute } from '@tanstack/react-router';
import { NewReportingWebhookRouteView } from '@/pages/workspaces/journeys/integrations/reporting-webhooks/routing';
import { LastWorkspaceResolver } from './-components';

function NewReportingWebhookRoute() {
  return (
    <LastWorkspaceResolver>
      <NewReportingWebhookRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new')({
  component: NewReportingWebhookRoute,
});
